export default __webpack_public_path__ + "static/media/download_circle.6f26cecc.svg";